import { render, staticRenderFns } from "./BlackGroup.vue?vue&type=template&id=3c0aad92&scoped=true&"
import script from "./BlackGroup.vue?vue&type=script&lang=js&"
export * from "./BlackGroup.vue?vue&type=script&lang=js&"
import style0 from "./BlackGroup.vue?vue&type=style&index=0&id=3c0aad92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0aad92",
  null
  
)

export default component.exports